const SectionForm = ({ icon, title, color = "yellow", children, withborder = true, ...props }) => (
    <div
        {...props} className={withborder ? `border-l-4 border-${color}-400 bg-${color}-50/40 rounded-lg p-4 sm:p-5` : `bg-${color}-50/40 rounded-lg p-4 sm:p-5`}
    >
        <h3
            className={`font-semibold text-base text-${color}-800 mb-2 flex items-center`}
        >
            {icon}&nbsp;{title}
        </h3>
        {children}
    </div>
);

export default SectionForm;